function toHankaku(val) {
  if (typeof val !== 'string') return val
  return val.replace(/[Ａ-Ｚａ-ｚ０-９！-～]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
  })
}

function* serialNumberGenerator() {
  let index = 0
  while (true) yield `field${index++}`
}

const serialNumber = serialNumberGenerator()

const generateDescription = function ({ name, text, hasHtml = false }) {
  return {
    name: name ?? serialNumber.next().value,
    type: 'component',
    componentName: 'Description',
    text,
    hasHtml,
  }
}

const generateNotice = function ({ text, hasHtml = false, isStrong = false }) {
  return {
    name: serialNumber.next().value,
    type: 'component',
    componentName: 'Notice',
    text,
    hasHtml,
    isStrong,
  }
}

const generateSubmitButton = function ({ name, defaultText, validText, loadingText, errorText }) {
  return {
    name: name ?? serialNumber.next().value,
    type: 'component',
    componentName: 'SubmitButton',
    defaultText,
    validText,
    loadingText,
    errorText: errorText ?? '送信に失敗しました。時間をおいてもう一度お試しください。',
  }
}

class FieldList {
  get planSelector() {
    return {
      name: 'plan_selector',
      title: 'プラン',
      type: 'component',
      componentName: 'PlanSelector',
      errorLabel: 'プラン',
      rules: { required: { allowFalse: false } },
      subFields: [this.contentSelector],
      // defaultValue: 'free',
    }
  }

  get contentSelector() {
    return {
      name: 'content_selector[]',
      title: 'コンテンツ',
      type: 'component',
      // componentName: 'PlanSelector',
      errorLabel: 'コンテンツ',
      rules: { required: { allowFalse: false } },
      defaultValue: [],
    }
  }

  get subscribingStatus() {
    return {
      name: 'available_plans',
      title: '',
      type: 'component',
      componentName: 'SubscribingStatus',
      errorLabel: 'プラン',
      rules: false,
    }
  }

  get name() {
    return {
      name: 'name',
      title: 'ご担当者氏名',
      type: 'text',
      placeholder: '(例) 印西 巻人',
      autocomplete: 'name',
      errorLabel: 'ご担当者氏名',
      rules: 'required',
      fa: 'fa-user',
    }
  }

  get email() {
    return {
      name: 'email',
      title: 'メールアドレス（ログインID）',
      type: 'email',
      placeholder: '(例) sample@example.com',
      autocomplete: 'email',
      errorLabel: 'メールアドレス',
      rules: { required: true, email: true },
      fa: 'fa-envelope',
    }
  }

  get resetEmail() {
    return {
      name: 'email',
      title: 'パスワードをリセットするメールアドレス（ログインID）',
      type: 'email',
      placeholder: window.gon?.email,
      autocomplete: 'email',
      errorLabel: 'メールアドレス',
      rules: undefined,
      fa: 'fa-envelope',
      disabled: true,
      cautionText:
        'このログインIDを使っているすべてのユーザーのパスワードが、新しいパスワードに変更されます',
    }
  }

  get phoneNumber() {
    return {
      name: 'phone_number',
      title: '電話番号',
      type: 'tel',
      placeholder: '0312345678',
      autocomplete: 'tel',
      errorLabel: '電話番号',
      rules: 'phone',
      fa: 'fa-phone',
      onBlur: toHankaku,
    }
  }

  get password() {
    return {
      name: 'password',
      title: 'ログインに使うパスワード',
      type: 'password',
      placeholder: '半角英数8文字以上',
      autocomplete: 'password',
      errorLabel: 'パスワード',
      rules: { required: true, min: { length: 8 } },
      fa: 'fa-lock',
    }
  }

  get passwordConfirmation() {
    return {
      name: 'password_confirmation',
      title: 'ログインに使うパスワード（確認）',
      type: 'password',
      placeholder: '上の欄と同じパスワードを入力してください',
      autocomplete: 'off',
      errorLabel: 'パスワード',
      rules: { required: true, confirmed: { target: 'password' } },
      fa: 'fa-lock',
    }
  }

  get newPassword() {
    return {
      name: 'password',
      title: 'ログインに使う新しいパスワード',
      type: 'password',
      placeholder: '半角英数x文字以上',
      autocomplete: 'password',
      errorLabel: 'パスワード',
      rules: { required: true, min: { length: 8 } },
      fa: 'fa-lock',
    }
  }

  get newPasswordConfirmation() {
    return {
      name: 'password_confirmation',
      title: 'ログインに使う新しいパスワード（確認）',
      type: 'password',
      placeholder: '上の欄と同じパスワードを入力してください',
      autocomplete: 'off',
      errorLabel: 'パスワード',
      rules: { required: true, confirmed: { target: 'password' } },
      fa: 'fa-lock',
    }
  }

  get companyName() {
    return {
      name: 'company_name',
      title: '会社・組織名',
      type: 'text',
      placeholder: '(例) ENECHANGE株式会社　需給管理部',
      autocomplete: 'organization',
      errorLabel: '会社・組織名',
      rules: 'required',
      fa: 'fa-building',
    }
  }

  get termsNew() {
    return {
      name: 'terms',
      title:
        '<a href="/markets/terms" target="_blank" rel="noopener">利用規約</a>と<a href="https://enechange.jp/articles/privacy_policy" target="_blank" rel="noopener">個人情報の取り扱いについて</a>を読み同意しました。',
      hasHtml: true,
      type: 'checkbox',
      errorLabel: '利用規約・個人情報の取り扱い',
      rules: { required: { allowFalse: false } },
    }
  }

  get termsEdit() {
    return {
      name: 'terms',
      title:
        'プランの変更にあたって<a href="/markets/terms" target="_blank" rel="noopener">利用規約</a>を確認しました。',
      hasHtml: true,
      type: 'checkbox',
      errorLabel: '利用規約・個人情報の取り扱い',
      rules: { required: { allowFalse: false } },
      condition: 'planConfirmation',
    }
  }

  get isSubscribing() {
    return {
      name: 'is_subscribing',
      title: '登録メールアドレスへのニュースレターの配信に同意しました。',
      hasHtml: true,
      type: 'checkbox',
      errorLabel: 'ニュースレター',
      rules: { required: { allowFalse: false } },
    }
  }

  get planConfirmationNew() {
    return {
      name: 'plan_confirmation',
      title:
        '有料プランでの会員登録は、ご登録いただいたメールアドレスへ弊社よりご連絡の上でのご契約となります。有料プランでのご契約締結までの期間は、無料会員として表示されます。',
      hasHtml: true,
      type: 'checkbox',
      errorLabel: '有料プラン',
      rules: { required: { allowFalse: false } },
      condition: 'planConfirmation',
    }
  }

  get planConfirmationEdit() {
    return {
      name: 'plan_confirmation',
      title:
        '有料プランへの変更は、ご登録いただいたメールアドレスへ弊社よりご連絡の上でのご契約となります。有料プランでのご契約締結までの期間は、無料会員として表示されます。',
      hasHtml: true,
      type: 'checkbox',
      errorLabel: '有料プラン',
      rules: { required: { allowFalse: false } },
      condition: 'planConfirmation',
    }
  }
}

const fieldList = new FieldList()

export default class FormFields {
  get default() {
    return []
  }

  get UsersNew() {
    return [
      generateDescription({
        text: 'ENECHANGE INSIGHT MARKETの新規会員登録をこちらで受け付けています。',
      }),
      fieldList.planSelector,
      fieldList.name,
      fieldList.email,
      fieldList.password,
      fieldList.passwordConfirmation,
      fieldList.companyName,
      fieldList.phoneNumber,
      fieldList.termsNew,
      fieldList.isSubscribing,
      fieldList.planConfirmationNew,
      generateSubmitButton({ defaultText: '会員登録' }),
    ]
  }

  get UsersEdit() {
    return [
      generateDescription({
        text: `ENECHANGE INSIGHT MARKETへの会員登録情報をこちらで変更できます。<br />
パスワードの再設定は、<a href="/markets/user/edit_password">パスワードの変更</a>からお願いいたします。`,
        hasHtml: true,
      }),
      fieldList.name,
      fieldList.email,
      fieldList.companyName,
      fieldList.phoneNumber,
      fieldList.subscribingStatus,
      // fieldList.termsEdit,
      // fieldList.planConfirmationEdit,
      generateSubmitButton({ defaultText: '設定を保存' }),
    ]
  }

  get UsersEditPassword() {
    return [
      generateDescription({
        text: 'ENECHANGE INSIGHT MARKETへのログインパスワードをこちらで変更できます。',
      }),
      fieldList.password,
      fieldList.passwordConfirmation,
      generateSubmitButton({ defaultText: 'パスワードを保存' }),
    ]
  }

  get LogIn() {
    return [
      generateDescription({
        text: 'ENECHANGE INSIGHT MARKETの会員の方はこちらでログインしてください。',
      }),
      fieldList.email,
      fieldList.password,
      generateSubmitButton({ defaultText: 'ログイン' }),
      generateNotice({
        text: `<a href="/markets/password_resets/new">パスワードを忘れた（再設定）</a>`,
        hasHtml: true,
        isStrong: true,
      }),
    ]
  }

  get PasswordResetsNew() {
    return [
      generateDescription({
        text: `登録されているメールアドレスを入力してください。<br />
        パスワードリセットメールを送信します。`,
        hasHtml: true,
      }),
      fieldList.email,
      generateNotice({
        text:
          'ログインIDに使用しているメールアドレスが不明な場合、ご面倒でも貴社ご担当者様へのお問い合わせをお願いいたします。',
        hasHtml: false,
      }),
      generateSubmitButton({ defaultText: 'リセットメールを送信' }),
    ]
  }

  get PasswordResetsEdit() {
    return [
      generateDescription({
        text: '新しいパスワードを登録してください。',
      }),
      fieldList.resetEmail,
      fieldList.newPassword,
      fieldList.newPasswordConfirmation,
      generateSubmitButton({ defaultText: '新しいパスワードを登録' }),
    ]
  }
}
